module.exports = __webpack_public_path__ + "368dd0baa254c6d8b6f90044f181ae35.pdf";